import React from 'react'
import { CandidateNavbar } from '../../components'

const Candidate = () => {
  return (
    <div>
      <CandidateNavbar />
    </div>
  )
}

export default Candidate